import { useContext, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";

import { ADDITIONAL_OFFSET, TranslationContext } from "@is/constants";
import { ViewStateContext } from "@is/contexts";
import { useScreenOrientation } from "@is/hooks";

type Props = {
  show: boolean;
  offset?: number;
  height?: number | string;
};

const useManagePendingSpinner = ({ show, offset = 0, height }: Props) => {
  const { t } = useTranslation(TranslationContext.ProductListing);
  const itemsLoadingAnchorRef = useRef<HTMLDivElement>(null);

  const { isPortraitView } = useScreenOrientation();

  const { showSearchAndFooterDrawers, sections } =
    useContext(ViewStateContext).content;

  useEffect(() => {
    if (show) {
      itemsLoadingAnchorRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [show]);

  const heightOfTheDrawer = useMemo(
    () =>
      isPortraitView && showSearchAndFooterDrawers
        ? offset + ADDITIONAL_OFFSET
        : 0,
    [isPortraitView, showSearchAndFooterDrawers, offset]
  );

  const heightOfTheSpinner = useMemo(() => {
    if (height) return height;
    return sections.length === 0
      ? "100vh"
      : `calc(100vh - ${heightOfTheDrawer}px)`;
  }, [sections.length, heightOfTheDrawer, height]);

  return { t, heightOfTheSpinner, itemsLoadingAnchorRef, heightOfTheDrawer };
};

export default useManagePendingSpinner;
